export enum ENUM__image_size_aspect_ratio {
  w3h1 = '3:1', //   111 x 37
  w2h1 = '2:1', //    91 x 45.5
  w16h9 = '16:9', //  80 x 45
  w3h2 = '3:2', //    75 x 50
  w4h3 = '4:3', //    64 x 48
  w5h4 = '5:4', //  62.5 x 50
  w6h5 = '6:5', //    75 x 62.5

  w1h1 = '1:1', //    64 x 64

  w5h6 = '5:6', //  62.5 x 75
  w4h5 = '4:5', //    50 x 62.5
  w3h4 = '3:4', //    48 x 64
  w2h3 = '2:3', //    50 x 75
  w9h16 = '9:16', //  45 x 80
  w1h2 = '1:2', //  45.5 x 91
  w1h3 = '1:3', //    37 x 111
}
